import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
} from "@angular/core";
import { MzBaseModal } from "ng2-materialize";
import { EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-confirm-sync",
  templateUrl: "./modal-sprint-start.component.html",
  styleUrls: ["./modal-sprint-start.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSprintStartComponent extends MzBaseModal {
  readonly result: EventEmitter<any> = new EventEmitter();
  env: any = environment;

  @Input() action: string = "";
  @Input() isJiraProject: boolean = false;

  modalOptions: Materialize.ModalOptions = {
    dismissible: false,
  };

  constructor() {
    super();
  }

  okClick() {
    this.result.emit(true);
  }

  abortClick() {
    this.result.emit(false);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/modal-sprint-start/modal-sprint-start.component.ts